import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  initialQuestionIds,
  responseIds,
} from '@aldebaran/common/constants/kb';
import { recordResponses } from '@/reducers/graph';
import { RootState } from '@/types/graph';

/**
 * Records the INTERLOCUTEUR KB response so the assertions that drive
 * question formulation ("Avez-vous…" vs "Le patient a-t-il…") are
 * injected into the graph. Fire from both the self-identification step
 * (when the patient picks SELF/OTHER) and the patient-information step
 * (for URL- or age-driven paths where self-id is skipped). Re-firing
 * with the same value is a no-op against assertions.
 */
export const useInjectInterlocuter = () => {
  const dispatch = useDispatch();
  const responses = useSelector((state: RootState) => state.kb.responses);
  const currentPage = useSelector(
    (state: RootState) => state.graph.currentPage,
  );

  return useCallback(
    (self: boolean) => {
      const selfResponse = responses[responseIds.INTERLOCUTER.SELF];
      const otherResponse = responses[responseIds.INTERLOCUTER.OTHER];
      if (!selfResponse || !otherResponse) return;
      dispatch(
        recordResponses({
          questionId: initialQuestionIds.INTERLOCUTER,
          currentPage,
          responses: [
            {
              ...(self ? selfResponse : otherResponse),
              value: { value: true },
            },
            {
              ...(self ? otherResponse : selfResponse),
              value: { value: false },
            },
          ],
        }),
      );
    },
    [dispatch, responses, currentPage],
  );
};
